module.exports = __webpack_public_path__ + "img/icon_solution_text02.91d7d851.png";